import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
export const CaseStudies = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100');
        entry.target.classList.remove('opacity-0', 'translate-y-10');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const caseStudies = [{
    title: "Lessons from UAC's Chi Acquisition",
    category: 'Mergers & Acquisitions',
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80',
    link: 'https://www.instagram.com/p/DNGBMaPtajS/?igsh=b3FxenR0cHlqc3Z3'
  }, {
    title: 'Restructuring for Global Expansion',
    category: 'Business Strategy',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80',
    link: 'https://www.instagram.com/p/DNYixYuN-3v/?img_index=6&igsh=M3J1NjhxdXM4Mmo2'
  }, {
    title: 'Post-Incorporation Compliance: Taxes, Permits & Regulatory Returns',
    category: 'Legal Insight',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    link: 'https://www.instagram.com/p/DOYNi4CDZak/?igsh=YXo0MGF3N2o5MW1u'
  }, {
    title: "Let's Talk Nigerian Business Entities - Why Many Founders Pick the Wrong One",
    category: 'Legal Insight',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80',
    link: 'https://www.instagram.com/p/DNOzeYVtqnr/?igsh=MTl2bzRyYjJlaGkzdA=='
  }, {
    title: 'CAC Registration Demystified: Your Step-by-Step Guide to Incorporation',
    category: 'Legal Insight',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    link: 'https://www.instagram.com/p/DNgECClNFlQ/?igsh=MTBicGxiZnRqaXZxNw=='
  }, {
    title: 'Understanding Product-Market Fit: Local vs. International Markets A must-know for founders, CEOs, and product teams.',
    category: 'Business Insight',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    link: 'https://www.instagram.com/p/DNn7mTENVkP/?img_index=1&igsh=MW5vNHBlYnc2bW8xMA=='
  }];
  return <section id="case-studies" className="py-20 bg-white" data-id="element-51">
      <div className="container mx-auto px-4" data-id="element-52">
        <div ref={sectionRef} className="text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 opacity-0 translate-y-10" data-id="element-53">
          <h2 className="text-primary font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-54">
            Insights & Case Studies
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-8" data-id="element-55"></div>
          <p className="text-gray-700" data-id="element-56">
            Explore our latest insights and case studies showcasing how we've
            helped businesses navigate complex challenges and achieve strategic
            objectives.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-57">
          {caseStudies.map((study, index) => <div key={index} className="group relative overflow-hidden rounded-md shadow-md transition-all duration-300 hover:shadow-xl" data-id="element-58">
              <a href={study.link || '#'} target="_blank" rel="noopener noreferrer" data-id="element-59">
                <div className="aspect-w-16 aspect-h-9 overflow-hidden" data-id="element-60">
                  <img src={study.image} alt={study.title} className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-61" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark to-transparent opacity-70" data-id="element-62"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transition-all duration-300 group-hover:bottom-2" data-id="element-63">
                  <span className="text-gold text-sm font-medium mb-2 block" data-id="element-64">
                    {study.category}
                  </span>
                  <h3 className="text-xl font-bold mb-4" data-id="element-65">{study.title}</h3>
                  <div className="flex items-center text-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-66">
                    <span className="mr-2" data-id="element-67">Read More</span>
                    <ArrowRight size={16} data-id="element-68" />
                  </div>
                </div>
              </a>
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-69">
          <a href="#all-insights" className="inline-flex items-center text-primary hover:text-gold transition-colors duration-300" data-id="element-70">
            <span className="mr-2" data-id="element-71">View All Insights</span>
            <ArrowRight size={16} data-id="element-72" />
          </a>
        </div>
      </div>
    </section>;
};